import { useQuery } from 'react-query'; 
import axiosInstance from './axiosInstance';

const fetchActiveModules = async () => {
  const response = await axiosInstance.get('/super-admin/active-module');
  return response.data;
};

export const useGetActiveModules = () => {
  return useQuery('activeModules', fetchActiveModules); 
};
